import React, { useState, useCallback } from 'react'
import SnackBar from 'src/components/era-package/era/SnackBar'

const TITLE = { success: 'Success', error: 'Error', warning: 'Warning', info: 'Info' }

export default function useMpciToast() {
  const [toast, setToast] = useState({ open: false, type: 'info', title: '', message: '', id: 0 })

  const showNotification = useCallback((type, message) => {
    setToast({ open: true, type, title: TITLE[type] || type, message, id: Date.now() })
  }, [])

  const toastNode = (
    <SnackBar
      key={toast.id}
      title={toast.title}
      type={toast.type}
      open={toast.open}
      onClose={() => setToast(prev => ({ ...prev, open: false }))}
      duration={toast.type === 'error' ? 8000 : 4000}
    >
      {toast.message || ''}
    </SnackBar>
  )

  return { showNotification, toastNode }
}
